import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SwipeYourAI from "./components/SwipeYourAI";
import AdminResultsViewer from "./components/AdminResultsViewer";

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<SwipeYourAI />} />
          <Route path="/admin" element={<AdminResultsViewer />} />
        </Routes>
      </Router>
  );
}

export default App;
